'use client';

import { useLocalStorage, useSet } from '@mantine/hooks';
import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export enum PROFILE_STATUS {
  REGISTRATION = 'registration',
  VERIFY = 'verify_email',
  COMPLETE = 'complete_profile',
  VERIFICATION = 'id_verification',
}
export type Successes = Set<PROFILE_STATUS | null>;
export type VerifyProfileContextProps = {
  verify: boolean;
  setVerify: (val: boolean | ((prevState: boolean) => boolean)) => void;
  status: PROFILE_STATUS | null;
  successes: Successes;
  setVerifyStatus: (status: PROFILE_STATUS | null) => void;
};
const VerifyProfileContext = createContext<VerifyProfileContextProps | null>(null);
export const VerifyProfileProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [verify, setVerify] = useLocalStorage({
    key: 'verify',
    defaultValue: false
  });
  const [status, setVerifyStatus] = useState<PROFILE_STATUS | null>(PROFILE_STATUS.REGISTRATION);
  const successes = useSet<PROFILE_STATUS | null>([PROFILE_STATUS.REGISTRATION]);
  return <VerifyProfileContext.Provider value={{
    verify,
    setVerify,
    status,
    setVerifyStatus,
    successes
  }}>
      {children}
    </VerifyProfileContext.Provider>;
};
export const useVerifyProfile = () => {
  const context = useContext(VerifyProfileContext);
  if (!context) {
    throw new Error('useVerifyProfile must be used within a VerifyProfileProvider');
  }
  return context;
};